import { apiClient } from '@api/client'
import { DiaryApi } from '@api/generated'

export const diaryApi = new DiaryApi(undefined, '', apiClient)
